import { Box, Text } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import LogoLoader from 'components/Loader/LogoLoader';
import Title from 'components/Title';
import Active from 'containers/Employees/EmployeeTabs/Active';
import { useFetchEmployeeGroupById } from 'hooks/employee/useFetchEmployeeGroupById';
import { IEmployeeSearchQuery } from 'hooks/employee/useFetchPaginatedEmployee';

const EmployeeGroupDetail: React.FC<unknown> = () => {
  const [searchQuery, setSearchQuery] = useState<IEmployeeSearchQuery>({
    page: 1,
    page_size: 25,
    active: '1',
    role: 'all',
    // is_register: '1',
    groupId: '',
    search: '',
    sort: '',
  });

  const { id } = useParams();
  const { data } = useFetchEmployeeGroupById(id!);

  useEffect(() => {
    if (id) {
      setSearchQuery({ ...searchQuery, groupId: id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!searchQuery.groupId) return <LogoLoader />;

  return (
    <Box>
      <Title>
        {data?.payload?.name}
        <Text as="span" ml={2} fontSize="sm" fontWeight={400} color="gray.500">
          ({`${data?.payload?.users?.length} users in group`})
        </Text>
      </Title>
      <Box mt="6">
        <Active initialSearchQuery={searchQuery} />
      </Box>
    </Box>
  );
};

export default EmployeeGroupDetail;
